<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-DIY表单管理-添加
    -->
    <el-dialog
    title="添加DIY表单管理"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
    
      <el-form-item label="所属" >
        <el-select v-model="form.bl" placeholder="请选择所属">
          <el-option v-for="(item,index) in diyform_bl" :key="index" :label="item.label" :value="item.val"></el-option>
        </el-select>
      </el-form-item>   
      
      
      <el-form-item label="类型" >
        <el-select v-model="form.code" placeholder="请选择类型">
          <el-option v-for="(item,index) in diyform_code" :key="index" :label="item.label" :value="item.val"></el-option>
        </el-select>
      </el-form-item>   

      
      <el-form-item label="图标：" prop="icon"  >
      <div class="draggable-list">
          <div v-if="form.icon">
              <div class="item">
                <img v-img-url="form.icon" alt="file_path"/>
                </div>
            </div>
        <div class="item img-select" @click="openProductUpload('icon')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


      <el-form-item label="字段标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入字段标题" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="key值" prop="keys">
        <el-input v-model="form.keys" placeholder="请输入key值" class="max-w460"></el-input>
        <div>对应数据库的字段</div>
      </el-form-item>

      
      <el-form-item label="输入框提示值" prop="keys">
        <el-input v-model="form.placeholder" placeholder="请输入输入框提示值" class="max-w460"></el-input>
    
      </el-form-item>


      <el-form-item label="其余字段设置" prop="setting">
        <el-input v-model="form.setting" type="textarea" placeholder="请输入其余字段设置" class="max-w460"></el-input>
      </el-form-item>


      <!-- 0 自动识别  1 手动填写  -->
    <el-form-item label="是否手动填写" >
          <el-radio-group v-model="form.is_auto">
            <el-radio :label="0">自动识别</el-radio>
            <el-radio :label="1">手动填写</el-radio>
          </el-radio-group>
     </el-form-item>

      <!--    0 不是必须  1  必须  -->
      <el-form-item label="是否必须" >
          <el-radio-group v-model="form.is_need">
            <el-radio :label="0">不是必须</el-radio>
            <el-radio :label="1">必须</el-radio>
          </el-radio-group>
     </el-form-item>



 


      <el-form-item label="排序" prop="name">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import DiyformApi from '@/api/diyform.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        keys:"",
        title:"",
        text:"",
        icon:"",
        placeholder:"",
        is_auto:"",
        is_need:"",
        code:"input",
        bl:"",

      },
      loading: false,
      /*验证规则*/
      rules: {
       
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"icon",
      diyform_bl:[],
      diyform_code:[],
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getSetting();
  },
  props: ["open_add"],
  methods: {
    getSetting(){
      var self = this;
      self.getSetting_common({
        "item":'diyform',
        "condi":['diyform_bl','diyform_code']
      },function(data){
          console.log('data',data)
          self.diyform_bl = data.obj.diyform_bl
          self.diyform_code = data.obj.diyform_code
      })
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          DiyformApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'icon'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        var icon = e[0].file_path;
          this.form.icon = icon;
          this.$set(this.form, "icon", icon);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'icon'){
        this.form.icon = "";
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/diyform/index/part/add.vue